 angular
   .module('vppApp')
   .service('AuthenticationService', AuthenticationService);

 AuthenticationService.$inject = ['$rootScope', '$base64', '$injector', 'vppConfig'];

 function AuthenticationService($rootScope, $base64, $injector, vppConfig) {
   var authenticationService = {};
   var isAuthed = false;
   var fName = '';
   var lName = '';
   $rootScope.userData = {};
   // Auth user obj creator
   var _createAuthUserObj = function (accountID, lastAccessTime, userEmail, userDetail) {
     var userDetailData = {};
     userDetailData.isActiveSalaryGMEmployee = false;
     userDetailData.isGMDomain = false;
     var hasPayrl = false
     var hasConsub = false;

     // check if this contains parsed data, if not, parse
     if (typeof userDetail !== 'undefined' && !userDetail.hasOwnProperty('isGMDomain')) {
       // check if email is GM domain
       var tmpEmailArr = userEmail ? userEmail.split("@") : '';
       var tmpEmailDomain = tmpEmailArr[tmpEmailArr.length - 1];

       // check if GM domain, set flag if true
       for (var key in vppConfig.gmdomains) {
         if (vppConfig.gmdomains[key] == tmpEmailDomain.toLowerCase()) {
           userDetailData.isGMDomain = true;
         }
       }

       if (userDetail != null && userDetail.data != null && userDetail.data.customerPartnerPart != null) {
         if (userDetail.data.customerPartnerPart.partnerType.toLowerCase() == 'div') {
           userDetailData.partnerType = userDetail.data.customerPartnerPart.partnerType;

           // loop through attributes looking for of payrltyp or consubtyp
           var attributeLength = userDetail.data.attributes.length;

           // if GM employee, set attributeParentCode, attributeCode
           if (userDetailData.isActiveSalaryGMEmployee == true) {
             userDetailData.attributeParentCode = userDetail.data.attributes[i].attributeParentCode;
             userDetailData.attributeCode = userDetail.data.attributes[i].attributeCode;

           } else {
             for (var i = 0; i < attributeLength; i++) {

              var parentCode = userDetail.data.attributes[i].attributeParentCode.toLowerCase();
              var attributeCode = userDetail.data.attributes[i].attributeCode.toLowerCase();

               if (parentCode === 'payrltyp') {
                 if (attributeCode === 'payrls') {
                   userDetailData.isActiveSalaryGMEmployee = hasPayrl = true;
                 }
               } else if (parentCode === 'consubtyp') {
                 if (attributeCode === 'consuba' || attributeCode === 'consubl') {
                   userDetailData.isActiveSalaryGMEmployee = hasConsub = true;
                 }
               }

               userDetailData.isActiveSalaryGMEmployee = userDetailData.isActiveSalaryGMEmployee && hasPayrl && hasConsub;

             }

           }

         }

       }

     } else {
       userDetailData = userDetail;
     }

     $rootScope.userData = {
       AuthUser: {
         userID: $base64.encode(accountID),
         lastAccessTime: lastAccessTime,
         userE: $base64.encode(userEmail || ''),
         userDetail: userDetailData
       }
     };

     $rootScope.userEmail = userEmail;
   };

   authenticationService.setUserDetail = function (userDetail, userEmail) {
     var userDetailData = {};
     userDetailData.isActiveSalaryGMEmployee = false;
     userDetailData.isGMDomain = false;
     var hasPayrl = false;
     var hasConsub = false;

     if (typeof userDetail !== 'undefined' && !userDetail.hasOwnProperty('isGMDomain')) {
       // check if email is GM domain
       var tmpEmailArr = userEmail ? userEmail.split("@") : '';
       var tmpEmailDomain = tmpEmailArr[tmpEmailArr.length - 1];

       // check if GM domain, set flag if true
       for (var key in vppConfig.gmdomains) {
         if (vppConfig.gmdomains[key] == tmpEmailDomain.toLowerCase()) {
           userDetailData.isGMDomain = true;
         }
       }

       if (userDetail != null && userDetail.data != null && userDetail.data.customerPartnerPart != null) {
         if (userDetail.data.customerPartnerPart.partnerType.toLowerCase() === 'div') {
           userDetailData.partnerType = userDetail.data.customerPartnerPart.partnerType;

           // loop through attributes looking for of payrltyp or consubtyp
           var attributeLength = userDetail.data.attributes.length;

           // if GM employee, set attributeParentCode, attributeCode
           if (userDetailData.isActiveSalaryGMEmployee == true) {
             userDetailData.attributeParentCode = userDetail.data.attributes[0].attributeParentCode;
             userDetailData.attributeCode = userDetail.data.attributes[0].attributeCode;

           } else {
             for (var i = 0; i < attributeLength; i++) {
               var parentCode = userDetail.data.attributes[i].attributeParentCode.toLowerCase();
               var attributeCode = userDetail.data.attributes[i].attributeCode.toLowerCase();

               if (parentCode === 'payrltyp') {
                 if (attributeCode === 'payrls') {
                   userDetailData.isActiveSalaryGMEmployee = true;
                   hasPayrl = true;
                 }
               } else if (parentCode === 'consubtyp') {
                 if (attributeCode === 'consuba' || attributeCode === 'consubl') {
                   userDetailData.isActiveSalaryGMEmployee = true;
                   hasConsub = true;
                 }
               }

               userDetailData.isActiveSalaryGMEmployee = userDetailData.isActiveSalaryGMEmployee && hasPayrl && hasConsub;

             }

           }

         }

       }

     } else {
       userDetailData = userDetail;
     }

     $rootScope.userData.AuthUser.userDetail = userDetailData;
   }


   authenticationService.setAuthentication = function (userData, userEmail, userDetail) {
     //console.log($base64.encode(userData.data.accountID));
     isAuthed = true;
     // create userObj from success
     _createAuthUserObj(userData.data.accountID, userData.data.lastAccessTime, userEmail, userDetail);
     // sets localStorage data
     window.localStorage['vppData'] = angular.toJson($rootScope.userData);
     // sets sessionStorage data
     window.sessionStorage.setItem("vppData", angular.toJson($rootScope.userData));
     var _userID = $base64.decode($rootScope.userData.AuthUser.userID);
     if (userData.data.firstName) {
       fName = $base64.encode(userData.data.firstName)
     }
     if (userData.data.lastName) {
       lName = $base64.encode(userData.data.lastName)
     }
   };

   authenticationService.destroyAuthentication = function () {
     // clear specific localstorage objects
     window.localStorage.removeItem("vppData");
     window.localStorage.removeItem("vppDataCustomer");
     window.localStorage.removeItem("vppDataProgram");
     window.localStorage.removeItem("vppDataUName");
     // clear specific sessionstorage objects
     window.sessionStorage.removeItem("vppData");
     window.sessionStorage.removeItem("vppDataCustomer");
     window.sessionStorage.removeItem("vppDataProgram");
     window.sessionStorage.removeItem("vppDataUName");
     $injector.get('CustomerService').destroyCustomer();
     $rootScope.userData = {};
     isAuthed = false;
   };

   authenticationService.getAuthenticatedID = function () {
     var _userID = '';
     if ($rootScope.userData && $rootScope.userData.AuthUser && $rootScope.userData.AuthUser.userID) {
       _userID = $base64.decode($rootScope.userData.AuthUser.userID);
     }
     return _userID;
   };

   authenticationService.getUserEmail = function () {
     var _userEmail = $base64.decode($rootScope.userData.AuthUser.userE);
     return _userEmail;
   };

   authenticationService.getFirstName = function () {
     var _userFN = $base64.decode(fName);
     return _userFN;
   };
   authenticationService.getLastName = function () {
     var _userLN = $base64.decode(lName);
     return _userLN;
   };
   authenticationService.isAuthenticated = function () {
     return isAuthed;
   };

   authenticationService.createUniqueID = function () {
     var _md5ID = $rootScope.userData.AuthUser.userID;
     return _md5ID;
   };

   // TO-DO ~~

   authenticationService.checkAuthenticated = function () {
     if (Object.keys($rootScope.userData).length === 0) {
       // $rootScope.userData is Empty
       var _tempSData = angular.fromJson(window.sessionStorage.getItem("vppData"));
       var _tempLData = angular.fromJson(window.localStorage.getItem("vppData"));
       // check sessionStorage & localStorage exists, userID matches, LastAccessTime matches, and not null
       if (_tempSData && _tempLData) {
         if ((_tempLData.AuthUser.userID === _tempSData.AuthUser.userID) && (_tempLData.AuthUser.lastAccessTime === _tempSData.AuthUser.lastAccessTime) && (_tempSData.AuthUser.userID !== null)) {
           _createAuthUserObj($base64.decode(_tempLData.AuthUser.userID), _tempLData.AuthUser.lastAccessTime, $base64.decode(_tempLData.AuthUser.userE), _tempLData.AuthUser.userDetail);
           isAuthed = true;
         } else {
           this.destroyAuthentication();
         }
       } else {
         this.destroyAuthentication();
       }
       // end
     }

   };

   // Check for $rootScope.userData

   // if no $rootScope.userData, possible page refresh, check for Session Storage, 

   // if Session Storage, check for Local Storage, verify last login time, set $rootScope.userData, set isAuthed = true.

   // if no  Session Storage, run destroitAuthentication ();



   return authenticationService;

 };